import { Routes, Route } from "react-router-dom";
import Products from "./components/products/products";
import ProductDetail from "./components/products/ProductDetail";
import Cart from "./components/Cart/Cart";
import Category from "./components/category/category";
import Arrivals from "./components/newarrivals/arrivals";
import Checkout from "./components/orders/Checkout";
import Success from "./components/orders/Success";
import Login from "./components/login/Login";
import SignupRequest from "./components/login/SignupRequest";
import SignupVerify from "./components/login/SignupVerify";
import ForgotPassword from "./components/login/ForgotPassword";
import ResetPassword from "./components/login/ResetPassword";
import OrderHistory from "./components/orders/OrderHistory";
import Admin from "./components/admin/Admin";
import OrdersAdmin from "./components/admin/OrdersAdmin";
import Adminproductlist from "./components/admin/Adminproductlist";
import Customers from "./components/admin/Customers";
import NewProducts from "./components/products/NewProducts";

import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminRoute from "./components/auth/AdminRoute";
import Footer from "./components/footer/Footer";

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Category />
            <Arrivals />
            <NewProducts />
            <Footer />
          </>
        }
      />
      <Route path="/products/:categoryName" element={<Products />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/success" element={<Success />} />
      <Route path="/signup" element={<SignupRequest />} />
      <Route path="/signup-verify" element={<SignupVerify />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* -------------------- USER PROTECTED -------------------- */}
      <Route
        path="/checkout"
        element={
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <OrderHistory />
          </ProtectedRoute>
        }
      />

      {/* -------------------- ADMIN ROUTES -------------------- */}
      <Route
        path="/adminpage"
        element={
          <AdminRoute>
            <Admin />
          </AdminRoute>
        }
      />

      <Route
        path="/admin/orders"
        element={
          <AdminRoute>
            <OrdersAdmin />
          </AdminRoute>
        }
      />

      <Route
        path="/admin/customer"
        element={
          <AdminRoute>
            <Customers />
          </AdminRoute>
        }
      />

      <Route
        path="/admin/listings"
        element={
          <AdminRoute>
            <Adminproductlist />
          </AdminRoute>
        }
      />

    </Routes>
  );
}

export default AppRoutes;